<script setup lang="ts">
import styles from '@/assets/sass/components/submenu.module.scss';
</script>
<template>
    <div :class="styles.submenu">

    </div>
</template>
